import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { GlobalComponent } from '../global/global.component';
import { GeneralService } from './general.service';

@Injectable({
  providedIn: 'root'
})
export class EligibilityReportService extends Subject<DataStateChangeEventArgs> {
  constructor(
    private http: HttpClient, 
    public global: GlobalComponent, 
    public general: GeneralService
  ) {
    super();
  }

  public ouputValues(state): void {
    this.getEligibility(state).subscribe(x => super.next(x));
  }

  getEligibility(state): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Claims/GetEligibilitySummaryList", state)
      .pipe(
        map((response: any) => (<any>{
          result: response['edi271clientlist'],
          count: response['totalCount']
        })),
        map((e: any) => {
          e.result.forEach(element => {
            // Additional processing if needed
          });
          return e;
        })
      );
  }
}
